// extracted by mini-css-extract-plugin
module.exports = {"leftToRight":"GCULoadingBar_leftToRight__1K2qW","rightToLeft":"GCULoadingBar_rightToLeft__3c1zc"};